// src/pages/Dashboard/components/FloorToday.jsx
// STATUS: active | UPDATED: 2026-08-30
// LOG:
//   2026-08-30  New. What a manager opens the app for.
//
// The dashboard was written for a salesperson and every role got it. A sales
// manager signed in and was shown a training plan, a streak and a coach card,
// none of which is their job. Their job is on the other side of a tab they had
// to know to click.
//
// So this sits at the top for a manager or an owner, and answers one question:
// is anybody waiting on me right now.
//
// ONE NUMBER, AND IT IS THE SHARP ONE
//
// A person sitting at check_passed has proved they know the step and is waiting
// on a human to watch them do it. That is the only number in this product that
// points at the manager rather than the floor, and it is the leading indicator
// of a store going quiet. Everything else a manager might want is one tap away
// on the floor page and does not belong on a landing screen.
//
// SILENT WHEN THERE IS NOTHING. No empty state, no zero, no card at all. A
// manager with nothing waiting should see the same clean screen as everybody
// else rather than a widget congratulating them.

import { useEffect, useState } from 'react'
import { Box, HStack, Text, Icon } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { ClipboardCheck, ArrowRight } from 'lucide-react'
import { listSignoffs } from '../../../lib/signoffs'

export default function FloorToday() {
  const [waiting, setWaiting] = useState(null)

  useEffect(() => {
    let live = true
    listSignoffs().then((res) => {
      if (!live || !res.ok) return
      // RLS already narrows this to the people this manager actually manages,
      // so there is no role check here and no second copy of the rule.
      setWaiting((res.signoffs || []).filter((s) => s.status === 'requested').length)
    })
    return () => {
      live = false
    }
  }, [])

  if (!waiting) return null

  return (
    <Box
      as={RouterLink}
      to="/team/"
      display="block"
      bg="ink"
      color="onInk"
      borderRadius="card"
      px={{ base: 5, md: 6 }}
      py={5}
      _hover={{ textDecoration: 'none', transform: 'translateY(-1px)' }}
      transition="transform 0.15s ease"
    >
      <HStack spacing={3} mb={1.5}>
        <Icon as={ClipboardCheck} boxSize={4} color="onInkMuted" />
        <Text textStyle="eyebrow" color="onInkMuted">
          Waiting on you
        </Text>
      </HStack>
      <Text fontSize="display-sm" fontWeight={600} letterSpacing="-0.02em" lineHeight={1.15} mb={1}>
        {waiting} {waiting === 1 ? 'person is' : 'people are'} ready to be signed off
      </Text>
      <HStack spacing={1.5} color="onInkMuted">
        <Text fontSize="body-sm">
          They have passed the check and need you to watch them run it
        </Text>
        <Icon as={ArrowRight} boxSize={3.5} />
      </HStack>
    </Box>
  )
}
